import React from "react";
import useAuth from "src/services/hooks/useAuth";
import SINOLogo from "../assets/images/logo_sino.svg";
import "./Header.css";

const Header = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated()) {
    return null;
  }

  return (
    <React.Fragment>
      <header>
        <img src={SINOLogo} style={{ height: "3em" }} alt="Logo" />
      </header>
      {window.__ENV__.REACT_APP_NODE_ENV === "development" && (
        <div className="header-notification">
          Du befindest dich auf dem <b>Development-System</b>! Die Daten werden
          regelmässig gelöscht
        </div>
      )}
    </React.Fragment>
  );
};

export default Header;
